import * as Types from '../../@types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AddTev2MonthlySongMutationVariables = Types.Exact<{
  year: Types.Scalars['Int']['input'];
  month: Types.Scalars['Int']['input'];
  tev2Banner: Types.Scalars['String']['input'];
  introductionBanner: Types.Scalars['String']['input'];
  vimeoId: Types.Scalars['String']['input'];
  tev2SongId: Types.Scalars['String']['input'];
}>;


export type AddTev2MonthlySongMutation = { __typename?: 'Mutation', addTev2MonthlySong: { __typename?: 'Payload', count: number, error?: Types.Error | null } };


export const AddTev2MonthlySongDocument = gql`
    mutation AddTev2MonthlySong($year: Int!, $month: Int!, $tev2Banner: String!, $introductionBanner: String!, $vimeoId: String!, $tev2SongId: String!) {
  addTev2MonthlySong(
    parameter: {year: $year, month: $month, tev2Banner: $tev2Banner, introductionBanner: $introductionBanner, vimeoId: $vimeoId, tev2SongId: $tev2SongId}
  ) {
    count
    error
  }
}
    `;
export type AddTev2MonthlySongMutationFn = Apollo.MutationFunction<AddTev2MonthlySongMutation, AddTev2MonthlySongMutationVariables>;

/**
 * __useAddTev2MonthlySongMutation__
 *
 * To run a mutation, you first call `useAddTev2MonthlySongMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTev2MonthlySongMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTev2MonthlySongMutation, { data, loading, error }] = useAddTev2MonthlySongMutation({
 *   variables: {
 *      year: // value for 'year'
 *      month: // value for 'month'
 *      tev2Banner: // value for 'tev2Banner'
 *      introductionBanner: // value for 'introductionBanner'
 *      vimeoId: // value for 'vimeoId'
 *      tev2SongId: // value for 'tev2SongId'
 *   },
 * });
 */
export function useAddTev2MonthlySongMutation(baseOptions?: Apollo.MutationHookOptions<AddTev2MonthlySongMutation, AddTev2MonthlySongMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTev2MonthlySongMutation, AddTev2MonthlySongMutationVariables>(AddTev2MonthlySongDocument, options);
      }
export type AddTev2MonthlySongMutationHookResult = ReturnType<typeof useAddTev2MonthlySongMutation>;
export type AddTev2MonthlySongMutationResult = Apollo.MutationResult<AddTev2MonthlySongMutation>;
export type AddTev2MonthlySongMutationOptions = Apollo.BaseMutationOptions<AddTev2MonthlySongMutation, AddTev2MonthlySongMutationVariables>;